import { initDatadogLogs, initDatadogRum } from './datadog'
import * as process from 'process'

const shouldCollectAnalytics = process.env.NODE_ENV === 'production'

function initClientSide() {
  initDatadogRum()
  initDatadogLogs()
}

if (shouldCollectAnalytics) {
  if (typeof window !== 'undefined') {
    // Check if we're running in the browser.
    initClientSide()
  }
}
